var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{ref:"submit",staticClass:"mr-2 text-medium submit-btn",class:( _obj = {
    'button-confettis': _vm.showConfettis,
    'confettis-on': _vm.animateConfettis
  }, _obj[_vm.submitBtnClass] = true, _obj ),attrs:{"sm":"","variant":_vm.variant || 'primary',"type":_vm.type,"disabled":_vm.isLoading || _vm.isSubmitDisabled,"pill":"","data-confettis":_vm.showConfettis},on:{"click":function($event){return _vm.$emit('save', $event)}}},[(_vm.isLoading)?_c('b-spinner',{attrs:{"small":""}}):[_vm._v("\n    "+_vm._s(_vm.btnText)+"\n  ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }